module.exports = __webpack_public_path__ + "static/media/solutions__buyer_access.09be009f.png";